import MainFooter from "../../module/footer/main_footer";
import SubNavBar from "../../module/nav_bar/sub_nav_bar";
import "./procedure_page.css";
import right_img from "../../img/service_right.png";
import class_info_img from "../../img/classification.png";
import class_img from "../../img/classification_procedure.png";
import service_img from "../../img/service_procedure.png";
import FixedBtn from "../../module/fixed_btn/fixed_btn";

function ProcedurePage() {
  return (
    <div className="procedure_page">
      <nav>
        <SubNavBar />
      </nav>
      <div className="page_header">
        <div className="page_title">이용절차</div>
      </div>
      <main className="procedure_main">
        <div className="procedure_container">
          <div className="right_container">
            <div className="process" id="right">
              1. 신청자격
            </div>
            <img className="procedure_img" src={right_img} />
          </div>
          <div className="class_container">
            <div className="process" id="class">
              2. 요양등급 신청절차
            </div>
            <img className="procedure_img" src={class_info_img} />
            <div id="class_img_container">
              <img className="procedure_img" id="class_img" src={class_img} />
            </div>
          </div>
          <div className="service_container">
            <div className="process" id="service">
              3. 서비스 이용절차
            </div>
            <img className="procedure_img" src={service_img} />
          </div>
        </div>
      </main>
      <FixedBtn />
      <footer>
        <MainFooter />
      </footer>
    </div>
  );
}

export default ProcedurePage;
